import React from 'react';
import { Card } from '@/components/ui/card';

interface StatCardProps {
  label: string;
  value: string | number;
  subLabel: string;
  icon: React.ReactNode;
}

export const StatCard: React.FC<StatCardProps> = ({ label, value, subLabel, icon }) => {
  return (
    <Card className="p-4 bg-neutral-50 border-neutral-100 flex flex-col gap-2 h-[148px] rounded-[16px]">
      <div className="size-10 bg-[#EAF0FF] rounded-[8px] flex items-center justify-center text-primary">
        {icon}
      </div>
      <div className="flex flex-col">
        <div className="flex items-baseline gap-1">
          <span className="text-2xl font-semibold text-dark leading-9">{value}</span>
          <span className="text-sm text-dark font-normal">{label}</span>
        </div>
        <p className="text-xs text-secondary font-normal">{subLabel}</p>
      </div>
    </Card>
  );
};
